import React from 'react'
import { Icon } from '@therms/atalaya'
import { MobileMenuLink } from '@src/modules/Layout/shared/MobileMenuLink'
import { SCHEDULING_ROUTES } from '../../constants'
import { FaCalendarAlt } from 'react-icons/fa'

function SchedulingMobileMenuLink() {
  return (
    <MobileMenuLink to={SCHEDULING_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={FaCalendarAlt} size="sm" />
        <span>Schedule</span>
      </div>
    </MobileMenuLink>
  )
}

export { SchedulingMobileMenuLink }
